import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Team } from "@common/ADAPT.Common.Model/organisation/team";
import { ArrayUtilities } from "@common/lib/utilities/array-utilities";
import { IDxListSelectionChangedEvent } from "@common/ux/dx.types";
import ArrayStore from "devextreme/data/array_store";
import DataSource from "devextreme/data/data_source";
import { CommonTeamsService } from "../common-teams.service";

@Component({
    selector: "adapt-select-teams",
    templateUrl: "./select-teams.component.html",
    styleUrl: "./select-teams.component.css",
    standalone: false,
})
export class SelectTeamsComponent implements OnInit {
    @Input() public filter?: (team: Team | null) => boolean;
    @Input() public showOrganisation = true;
    @Input() public singleSelection = false;
    @Input() public selectedTeamIds: (number | null)[] = [];
    @Output() public teamsSelectedChange = new EventEmitter<(Team | null)[]>();

    public dataSource?: DataSource;
    private selectedItems: (Team | null)[] = [];
    private isInitialised = false;

    public constructor(
        private teamsService: CommonTeamsService,
    ) { }

    public async ngOnInit() {
        const teams: (Team | null)[] = await this.teamsService.promiseToGetAllActiveTeams();
        if (this.showOrganisation) {
            teams.unshift(null);
        }
        teams.sort((a, b) => {
            if (a === null) return -1;
            if (b === null) return 1;
            return a.name.localeCompare(b.name);
        });
        this.dataSource = new DataSource({
            store: new ArrayStore({
                data: teams,
                key: "teamId",
            }),
            sort: "name",
            filter: this.filter,
        });
        this.dataSource.paginate(false); // need to disable pagination or we won't be able to find index of item for 2+ pages
    }

    public onSelectionChanged(e: IDxListSelectionChangedEvent<Team>) {
        if (e.addedItems?.length) {
            ArrayUtilities.addElementIfNotAlreadyExists(this.selectedItems, ...e.addedItems);
        }

        if (e.removedItems?.length) {
            e.removedItems.forEach((removedItem) => ArrayUtilities.removeElementFromArray(removedItem, this.selectedItems));
        }

        this.teamsSelectedChange.emit(this.selectedItems);
        if (this.selectedTeamIds.length > 0 && !this.isInitialised) {
            // first selection callback when the dialog opens - scroll to the first pre-selected team
            this.isInitialised = true;
            const selectedIndex = this.dataSource?.items().findIndex((item) => item?.teamId === this.selectedTeamIds[0]) ?? -1;
            if (selectedIndex > 0) { // won't bother if index is 0 as it is already visible
                setTimeout(() => {
                    e.component?.scrollToItem(selectedIndex);
                });
            }
        }
    }

    public searchTeamFunction = (team: Team | null) => {
        return team?.name ?? "Organisation";
    };
}
